export const LOYALTY_BADGE_CLICK = 'LOYALTY_BADGE_CLICK';
